
import React from "react";
import {
  InstagramOutlined,
  FacebookOutlined,
  TwitterOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

export default function ContactModal({ closeContact, workingHours, socialLinks }) {
  return (
    <div className="modal fullscreen" role="dialog" aria-modal="true">
      <div className="modal-inner">
        <button className="close-btn" onClick={closeContact}>×</button>
        <h3 className="contact-modal-title">Contact Information</h3>
        <div className="contact-modal-content">
          <section className="menu-contact-section">
            <h4>Contact Us</h4>
            <p><strong>Phone:</strong> +91 123 456 7890</p>
            <p><strong>Email:</strong> rajeshchamola@gmail.com</p>
            <div className="social-icons">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <InstagramOutlined />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FacebookOutlined />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <TwitterOutlined />
              </a>
              <a href="https://wa.me/911234567890" target="_blank" rel="noopener noreferrer">
                <WhatsAppOutlined />
              </a>
            </div>
          </section>
          <section className="menu-hours-section">
            <h4>Opening Hours</h4>
            <table>
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Hours</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Monday</td><td>{workingHours.Monday}</td></tr>
                <tr><td>Tuesday</td><td>{workingHours.Tuesday}</td></tr>
                <tr><td>Wednesday</td><td>{workingHours.Wednesday}</td></tr>
                <tr><td>Thursday</td><td>{workingHours.Thursday}</td></tr>
                <tr><td>Friday</td><td>{workingHours.Friday}</td></tr>
                <tr><td>Saturday</td><td>{workingHours.Saturday}</td></tr>
                <tr><td>Sunday</td><td>{workingHours.Sunday}</td></tr>
              </tbody>
            </table>
          </section>
          {socialLinks.length > 0 && (
            <div className="social-links">
              {socialLinks.map((link, index) => (
                <a key={index} href={link.url} target="_blank" rel="noopener noreferrer">
                  <i className={`fa fa-${link.icon}`}></i>
                </a>
              ))}
            </div>
          )}
          <div className="menu-copyright">
            © 2025 Digea. All rights reserved.
          </div>
          <div className="menu-product-of">
            Product of <a href="https://netshineoffice.com">NetShine Office</a>
          </div>
        </div>
      </div>
      <style jsx>{`
        .contact-modal-title {
          text-align: center;
          font-size: 1.8rem;
          margin-bottom: 20px;
          color: var(--text);
          font-weight: bold;
        }
        .contact-modal-content {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .menu-contact-section {
          padding: 20px;
          background: var(--card);
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          text-align: center;
        }
        .menu-contact-section h4 {
          font-size: 1.4rem;
          margin-bottom: 15px;
          color: var(--text);
        }
        .menu-contact-section p {
          margin: 8px 0;
          color: var(--muted);
          font-size: 1rem;
        }
        .menu-contact-section strong {
          color: var(--text);
        }
        .social-icons {
          display: flex;
          justify-content: center;
          gap: 20px;
          margin-top: 15px;
        }
        .social-icons a {
          font-size: 2.2rem;
          color: var(--muted);
          transition: color 0.3s ease, transform 0.3s ease;
        }
        .social-icons a:hover {
          transform: scale(1.15);
        }
        .social-icons a.instagram:hover { color: #E1306C; }
        .social-icons a.facebook:hover { color: #1877F2; }
        .social-icons a.twitter:hover { color: #1DA1F2; }
        .social-icons a.whatsapp:hover { color: #25D366; }
        .menu-hours-section {
          padding: 20px;
          background: var(--card);
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          text-align: center;
        }
        .menu-hours-section h4 {
          font-size: 1.4rem;
          margin-bottom: 15px;
          color: var(--text);
        }
        .menu-hours-section table {
          width: 100%;
          border-collapse: collapse;
          margin: 0 auto;
        }
        .menu-hours-section th, .menu-hours-section td {
          padding: 12px 15px;
          text-align: left;
          border-bottom: 1px solid rgba(0,0,0,0.1);
        }
        .menu-hours-section th {
          background: var(--accent);
          color: #fff;
          font-weight: bold;
        }
        .menu-hours-section tbody tr:nth-child(odd) {
          background: #f9f9f9;
        }
        .menu-hours-section td:first-child {
          font-weight: bold;
          color: var(--text);
        }
        .social-links {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
        }
        .social-links a {
          font-size: 1.8rem;
          color: var(--accent);
          transition: color 0.3s ease;
        }
        .social-links a:hover {
          color: var(--text);
        }
        .menu-copyright, .menu-product-of {
          text-align: center;
          color: var(--muted);
          font-size: 0.9rem;
          margin-top: 10px;
        }
        .menu-product-of a {
          color: var(--accent);
          text-decoration: none;
        }
        .menu-product-of a:hover {
          text-decoration: underline;
        }
        @media (max-width: 600px) {
          .modal-inner {
            padding: 20px;
          }
          .contact-modal-title {
            font-size: 1.5rem;
          }
          .menu-contact-section h4, .menu-hours-section h4 {
            font-size: 1.2rem;
          }
          .social-icons a {
            font-size: 1.8rem;
          }
          .menu-hours-section th, .menu-hours-section td {
            padding: 8px 10px;
          }
        }
      `}</style>
    </div>
  );
}